import { SortDirection } from "./directions";

export interface UxSort {
    dir: SortDirection;
    key: string;
}
